import "./Intro.css";

const Intro = () => {
  return (
    <>
      {/* HERO */}
      <section className="nxo-hero d-flex align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 col-md-9">
              <h1 className="logo">
                <img src="/assets/images/intro/logo.png" alt="NX Optics" />
              </h1>
            </div>

            <div className="col-lg-4 col-md-3 text-lg-end text-start mt-4 mt-md-0">
              <a href="#about" className="get-started-btn">
                GET STARTED →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="nxo-about-section" id="about">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 mb-4 mb-lg-0">
              <div className="image-card">
                <img src="/assets/images/intro/about-img.png" alt="" />
              </div>
            </div>

            <div className="col-lg-7">
              <h3 className="section-title">Empowering Connectivity for All</h3>
              <p className="section-text">
                At NXOptics, our mission is to revolutionize telecommunications by
                creating seamless and efficient communication solutions across
                the globe.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="nxo-benefits">
        <div className="container">
          <h2 className="benefits-title mb-5">Key Benefits</h2>

          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <div className="benefit-card">
                <h4>Unmatched Speed</h4>
                <p>Lightning-fast data transfer for modern workloads.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="benefit-card">
                <h4>Enhanced Connectivity</h4>
                <p>Reliable connectivity across urban and rural areas.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="benefit-card">
                <h4>Vendor Agnostic</h4>
                <p>Freedom from hardware lock-in and faster innovation.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FUTURE */}
      <section className="nxo-future">
        <div className="container">
          <h2 className="future-title mb-5">Future Innovations</h2>

          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <div className="future-card">
                <div className="icon-circle">
                  <img src="/assets/images/intro/01.png" alt="" />
                </div>
                <h4>Next-Gen Networks</h4>
                <p>Seamless connectivity with ultra-low latency.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="future-card">
                <div className="icon-circle">
                  <img src="/assets/images/intro/02.png" alt="" />
                </div>
                <h4>WiFi 6E & 7</h4>
                <p>High throughput using the 6GHz spectrum.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="future-card">
                <div className="icon-circle">
                  <img src="/assets/images/intro/03.png" alt="" />
                </div>
                <h4>InfiniBand</h4>
                <p>Ultra-low latency for AI & HPC clusters.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* QUOTE */}
      <section className="nxo-quote">
        <div className="container text-center">
          <p className="quote-text">
            “Innovate, Connect, Evolve” – the future of telecommunications is here.
          </p>
        </div>
      </section>

      {/* METRICS */}
      <section className="metrics-section">
        <div className="container">
          <h2 className="metrics-title">Key Metrics</h2>

          <div className="metric-card">
            <div>
              <h3>1,000,000+</h3>
              <span>Connected Devices</span>
            </div>
          </div>

          <div className="metric-card">
            <div>
              <h3>99.9%</h3>
              <span>Uptime Rate</span>
            </div>
          </div>

          <div className="metric-card">
            <div>
              <h3>50%</h3>
              <span>Latency Reduction</span>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="bulk-contact-section">
        <div className="container">
          <h2 className="section-title">Get in Touch for Bulk Orders</h2>

          <div className="row g-4 mt-4">
            <div className="col-md-4">
              <div className="contact-card">
                <h6>SALES</h6>
                <p>sales@nxoptics.com</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="contact-card">
                <h6>SUPPORT</h6>
                <p>support@nxoptics.com</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="contact-card">
                <h6>WEBSITE</h6>
                <p>www.nxoptics.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Intro;
